import React from "react";
import Banner from "../../components/Banner/Banner";
import UserGoldChit from "../Chit/UserGoldChit";
import Chit from "../Chit/Chit";
import GoldChitAd from "../Chit/GoldChitAd";

const Home = () => {
  return (
    <div className="w-full mx-auto">
      <Banner />
      <GoldChitAd />
      <Chit />
      <div className="max-w-container mx-auto px-4">
        {/* <Sale />
        <NewArrivals />
        <BestSellers />
        <YearProduct />
        <SpecialOffers /> */}
      </div>
    </div>
  );
};

export default Home;
